import React, { useState } from 'react';
import styled from 'styled-components';
import { formatDateTimeToFr, formatDateTimeToDate } from '../../utils/alertUtils';

interface AlertNavigationProps {
  refChanged: (tab: string) => void;
  actionsLength?: number;
  importedDate?: string;
}
interface TabButtonProps {
  isActive: boolean;
}

const TabList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 10px;
`;

const TabButton = styled.button<TabButtonProps>`
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  border: ${({ isActive }) => (isActive ? 'none' : '1px solid #ccc')};
  background-color: ${({ isActive }) => (isActive ? '#007bff' : '#fff')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#333')};
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? '#007bff' : '#f0f0f0'};
  }
`;

const AlertNavigation: React.FC<AlertNavigationProps> = ({ actionsLength, refChanged, importedDate }) => {
  const [activeTab, setActiveTab] = useState<string>("ALL");

  return ( 
      <TabList>
        <>
          <div>
            <div style={{ flexGrow: 1, alignSelf: 'right', fontFamily: 'system-ui' }}>
              <span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{"Carrefour Magasin - "}</span>
              <span style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>{formatDateTimeToFr(importedDate, 1)}</span>
              <span style={{ fontSize: '.8rem', fontWeight: 'normal' }}> données mises à jours le {formatDateTimeToDate(importedDate)}</span>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <TabButton
              key="ALL"
              isActive={activeTab === "ALL"}
              onClick={() => { refChanged("ALL"); setActiveTab("ALL"); }}>
              Tout
            </TabButton>
            <TabButton
              key="ACTIONS"
              isActive={activeTab === "ACTIONS"}
              onClick={() => { refChanged("ACTIONS"); setActiveTab("ACTIONS"); }}>
              Action requise <strong>({actionsLength || 0})</strong>
            </TabButton>
          </div>
        </>
      </TabList>
  );
};

export default AlertNavigation;
